import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManagerState } from './manager.state';

export const selectManagerState = createFeatureSelector<ManagerState>('manager');

export const selectManagedCompanies = createSelector(selectManagerState, state => state.managedCompanies);
export const selectLoadingManagedCompanies = createSelector(selectManagerState, state => state.loadingManagedCompanies);
export const selectProcesses = createSelector(selectManagerState, state => state.processes);
export const selectProcessesPagination = createSelector(selectManagerState, state => state.processesPagination);
export const selectLoadingProcesses = createSelector(selectManagerState, state => state.loadingProcesses);
